<template>
  <el-row class="container-card el-row">
    <Videos />
  </el-row>
</template>

<script>
import Videos from '../components/Table'

export default {
  components: {
    Videos
  }
}
</script>
